document.addEventListener('DOMContentLoaded', function() {
  const token = 'IWISH_API_8a7482dc423511f0bf350e72f2521631';

  // Rate limiting configuration
  const RATE_LIMIT = {
    maxRetries: 3,
    baseDelay: 1000, // 1 second
    maxDelay: 8000,  // 8 seconds
    requestDelay: 100 // 100ms between requests during initialization (reduced from 300ms)
  };

  // Helper function to wait/sleep
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  // Helper function to make API calls with retry logic
  async function makeApiCall(url, method = 'GET', data = null, retryCount = 0) {
    const options = {
      method: method,
      headers: {
        'xtoken': token,
        'Accept': 'application/json'
      }
    };

    if (data && method === 'POST') {
      options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      options.body = new URLSearchParams(data).toString();
    }

    try {
      const response = await fetch(url, options);
      
      // Handle rate limiting (429) with retry logic
      if (response.status === 429) {
        if (retryCount < RATE_LIMIT.maxRetries) {
          const delay = Math.min(
            RATE_LIMIT.baseDelay * Math.pow(2, retryCount),
            RATE_LIMIT.maxDelay
          );
          await sleep(delay);
          return makeApiCall(url, method, data, retryCount + 1);
        } else {
          throw new Error(`Rate limit exceeded after ${RATE_LIMIT.maxRetries} retries`);
        }
      }
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      return result;
    } catch (error) {
      throw error;
    }
  }

  // Add to wishlist function
  async function addToWishlist(element) {
    const customerId = parseInt(element.getAttribute('customer_id'));
    const productId = parseInt(element.getAttribute('product_id'));
    const variantId = parseInt(element.getAttribute('variant_id'));

    if (!customerId || !productId || !variantId) {
      return;
    }

    try {
      const url = 'https://api.myshopapps.com/wishlist/V2/addToWishlist';
      const data = {
        customer_id: customerId,
        product_id: productId,
        variant_id: variantId,
        category_id: 0,
        product_qty: 1
      };

      const response = await makeApiCall(url, 'POST', data);
      
      // Convert result to uppercase for case-insensitive comparison
      const result = (response.result || '').toString().toUpperCase();
      
      if (result === 'OK') {
        element.classList.remove('is--empty');
        element.classList.add('is--filled');
      }
    } catch (error) {
      // Silent error handling
    }
  }

  // Remove from wishlist function
  async function removeFromWishlist(element) {
    const customerId = parseInt(element.getAttribute('customer_id'));
    const productId = parseInt(element.getAttribute('product_id'));
    const variantId = parseInt(element.getAttribute('variant_id'));

    if (!customerId || !variantId) {
      return;
    }

    try {
      const url = `https://api.myshopapps.com/wishlist/V2/removeWishlist?customer_id=${customerId}&variant_id=${variantId}&category_id=0`;
      
      const response = await makeApiCall(url, 'DELETE');
      
      // Convert result to uppercase for case-insensitive comparison
      const result = (response.result || '').toString().toUpperCase();
      
      if (result === 'OK') {
        element.classList.remove('is--filled');
        element.classList.add('is--empty');
      }
    } catch (error) {
      // Silent error handling
    }
  }

  // Check if item is in wishlist function
  async function checkInWishlist(element) {
    const customerId = parseInt(element.getAttribute('customer_id'));
    const productId = parseInt(element.getAttribute('product_id'));
    const variantId = parseInt(element.getAttribute('variant_id'));

    if (!customerId || !variantId) {
      return;
    }

    try {
      const url = `https://api.myshopapps.com/wishlist/V2/checkInWishlist?customer_id=${customerId}&variant_id=${variantId}`;
      
      const response = await makeApiCall(url, 'GET');
      
      // Convert result to uppercase for case-insensitive comparison
      const result = (response.result || '').toString().toUpperCase();
      
      if (result === 'TRUE') {
        element.classList.remove('is--empty');
        element.classList.add('is--filled');
      } else if (result === 'FALSE') {
        element.classList.remove('is--filled');
        element.classList.add('is--empty');
      }
    } catch (error) {
      // Silent error handling
    }
  }

  // Event delegation for wishlist clicks
  document.addEventListener('click', function(event) {
    const target = event.target.closest('.tooltip.favourite');
    if (!target) return;

    // Handle empty wishlist items (add to wishlist)
    if (target.classList.contains('is--empty') && !target.classList.contains('no-customer')) {
      event.preventDefault();
      addToWishlist(target);
    }
    
    // Handle filled wishlist items (remove from wishlist)
    else if (target.classList.contains('is--filled') && !target.classList.contains('no-customer')) {
      event.preventDefault();
      removeFromWishlist(target);
    }
    
    // Handle no-customer clicks (login prompt)
    else if (target.classList.contains('no-customer')) {
      event.preventDefault();
      
      if (target.classList.contains('must-login')) {
        document.querySelectorAll('.tooltip.favourite.no-customer').forEach(el => {
          el.classList.remove('must-login');
        });
      } else {
        document.querySelectorAll('.tooltip.favourite.no-customer').forEach(el => {
          el.classList.remove('must-login');
        });
        target.classList.add('must-login');
      }
    }
  });

  // Handle clicks outside of login prompts
  document.body.addEventListener('click', function(event) {
    if (!event.target.closest('.tooltip.favourite.no-customer.must-login')) {
      document.querySelectorAll('.tooltip.favourite.no-customer').forEach(el => {
        el.classList.remove('must-login');
      });
    }
  });

  // Initialize wishlist status for all items on page load with rate limiting
  async function initializeWishlistStatus() {
    const wishlistElements = document.querySelectorAll('.tooltip.favourite:not(.no-customer)');

    if (wishlistElements.length === 0) {
      return;
    }

    for (let i = 0; i < wishlistElements.length; i++) {
      const element = wishlistElements[i];
      
      try {
        await checkInWishlist(element);
        
        // Add delay between requests to avoid rate limiting (except for the last item)
        if (i < wishlistElements.length - 1) {
          await sleep(RATE_LIMIT.requestDelay);
        }
      } catch (error) {
        // Continue with next item even if one fails
      }
    }
  }

  // Start initialization
  initializeWishlistStatus();
});